
// CACHES
import sample_cache from './sample-cache.js';

export default [
	sample_cache
];
